(function() {
    'use strict';
    /**
     Enhances text input view
     @param textInput DOM Object
     @private
     */

    Odigeo.UIElements.enhanceRange = function(textInput) {
        var $textInput = (textInput instanceof $) ? textInput : $(textInput);
        if (!textInput || !($textInput instanceof $)) {
            return;
        }
        if ($textInput.attr('data-skip-enhance') === 'true') {
            return;
        }

        Odigeo.Session.set('UIRangeBlocked', 'false');

        $textInput.attr({'data-skip-enhance': true});

        // For inputs of types:
        //  text, search, tel, url, email, password, datetime, date, month,
        //  week, time, datetime-local, number, color and also for TEXTAREA element
        //  add class "od-input-text".
        $textInput.addClass('od-input-text');

        var isInputElement = (textInput.nodeName === 'INPUT');
        var textInputType = $textInput.attr('data-type');
        var unitLetter = $textInput.data('unitLetter');

        var unitTypesConfigurations = {
            'hour': new TimeUnitTypeConfiguration(unitLetter),
            'km': new DistanceUnitTypeConfiguration(),
        };

        var getUnitConfiguration = function($element) {
            var unit = $element.attr('unit');
            if (Odigeo._.has(unitTypesConfigurations, unit)) {
                return unitTypesConfigurations[unit];
            } else {
                return unitTypesConfigurations.hour;
            }
        };

        // For inputs of types "range" and "search" change type to "text".
        if (textInputType === 'number' || textInputType === 'range') {
            var minValue = $textInput.attr('min');
            var maxValue = $textInput.attr('max');
            var minBound = (!Odigeo._.isNaN(parseFloat($textInput.attr('min-bound')))) ? parseFloat($textInput.attr('min-bound')) : minValue;
            var maxBound = (!Odigeo._.isNaN(parseFloat($textInput.attr('max-bound')))) ? parseFloat($textInput.attr('max-bound')) : maxValue;
            var toValue = (!Odigeo._.isNaN(parseFloat($textInput.attr('to')))) ? parseFloat($textInput.attr('to')) : maxBound;
            var fromValue = (!Odigeo._.isNaN(parseFloat($textInput.attr('from')))) ? parseFloat($textInput.attr('from')) : null;
            var isDoubleRange = fromValue !== null;
            var style = $textInput.data('style');
            var labelVisibility = !Odigeo._.isUndefined($textInput.data('label-visibility')) ? $textInput.data('label-visibility') : true;
            var id = $textInput.attr('id');
            var unitConfiguration = getUnitConfiguration($textInput);

            var step = parseFloat($textInput.attr('step')) || 1;

            // For inputs of types "range" and "number" change type to "text".
            var newTextInput = $('<input readonly="true" type="text" />');
            var newTIAttrs = {};
            Odigeo._.each(textInput.attributes, function(attribute) {
                if (attribute.name === 'type') {
                    return;
                }
                newTIAttrs[attribute.name] = attribute.value;
            });
            newTextInput.attr(newTIAttrs);
            newTextInput.attr({'data-skip-enhance': true});

            var numberWrapper = $('<div>').addClass('od-input-number');
            if ($textInput.data('number-field') === false) {
                numberWrapper.addClass('od-hidden');
            }
            numberWrapper.append(
                $('<button>', {type: 'button', text: '-'})
                    .addClass('od-input-number-control od-input-number-control-decrease')
                    .attr({'data-skip-enhance': true})
                    .append(
                        $('<span>').addClass('od-icon od-icon-big od-icon-minus-circled')
                    )
            );
            numberWrapper.append(newTextInput);
            numberWrapper.append(
                $('<button>', {type: 'button', text: '+'})
                    .addClass('od-input-number-control od-input-number-control-increase')
                    .attr({'data-skip-enhance': true})
                    .append($('<span>').addClass('od-icon od-icon-big od-icon-plus-circled'))
            );

            var rangeWrapper = null;

            var calcPerc = function(newValue) {
                var val = (newValue - Math.max(minBound, minValue)) / (Math.min(maxBound, maxValue) - Math.max(minBound, minValue));
                return (Odigeo._.isNaN(val) ? 0 : val);
            };

            var realWidth = function(obj) {
                var $visibleParent = obj.closest('section');
                var width;
                var $closesFilterItem;
                var isActive;
                var isAlreadyVisible;

                isAlreadyVisible = $visibleParent.is(':visible');
                if (!isAlreadyVisible) {
                    $visibleParent.addClass('visibleForced');
                }
                $closesFilterItem = obj.closest('.filter_items');
                isActive = $closesFilterItem.hasClass('active');
                if (!isActive) {
                    $closesFilterItem.addClass('active');
                }
                width = obj.parent().find(obj).width();
                if (!isActive) {
                    $closesFilterItem.removeClass('active');
                }
                if (!isAlreadyVisible) {
                    $visibleParent.removeClass('visibleForced');
                }
                return width;
            };

            var changeRangeLook = function() {
                var newValue;
                var fatherRange;
                var boundRange;
                var activeRange;
                var borderTop;
                var width;
                var percBound;
                var percValue;
                var leftWidth;
                var height;
                var percFromValue;
                var percActive;

                if (!isDoubleRange) {
                    // It's one value, in this case, we have two different styles, similar to line or ascendant triangle
                    if (style === 'line') {
                        newValue = toValue;
                        fatherRange = rangeWrapper.find('.range_slider');
                        boundRange = rangeWrapper.find('.range_slider_bound');
                        activeRange = rangeWrapper.find('.range_slider_track');
                        width = realWidth(fatherRange);
                        percBound = (maxBound - minBound) / (maxValue - minValue) || 0;
                        percActive = calcPerc(newValue);
                        leftWidth = width * (minBound - minValue) / (maxValue - minValue) || 0;
                        if (minValue === maxValue) {
                            percBound = 1;
                            leftWidth = 0;
                        }
                        width = percBound * width;
                        boundRange.css({
                            'width': '' + width + 'px',
                            'left': '' + leftWidth + 'px',
                        });
                        activeRange.width(width * percActive + 'px');
                        rangeWrapper.find('.range_slider_control').width(width * percActive + 'px');
                        rangeWrapper.find('.range_slider_thumb').attr({'title': newValue});
                        rangeWrapper.find('.range_slider_num').html(newValue);
                    } else {
                        newValue = toValue;
                        fatherRange = rangeWrapper.find('.range_slider');
                        boundRange = rangeWrapper.find('.range_slider_bound');
                        activeRange = rangeWrapper.find('.range_slider_track');
                        borderTop = parseFloat(fatherRange.css('border-top-width').replace('px', ''));
                        width = realWidth(fatherRange);
                        percBound = (maxBound - minBound) / (maxValue - minValue) || 0;
                        percValue = calcPerc(newValue);
                        leftWidth = width * (minBound - minValue) / (maxValue - minValue) || 0;
                        height = borderTop * leftWidth / width;
                        if (minValue === maxValue) {
                            percBound = 1;
                            percValue = 1;
                            leftWidth = 0;
                            height = 0;
                        }
                        width = percBound * width;
                        borderTop = percBound * borderTop;
                        activeRange.css({
                            'border-top-width': '' + ((borderTop * percValue) + height) + 'px',
                            'width': '' + width * percValue + 'px',
                        });
                        boundRange.css({
                            'border-top-width': '' + (borderTop + height) + 'px',
                            'width': '' + width + 'px',
                            'left': '' + leftWidth + 'px',
                        });
                        rangeWrapper.find('.range_slider_control').width(width * percValue + 'px');
                        rangeWrapper.find('.range_slider_thumb').attr({'title': newValue});
                        rangeWrapper.find('.range_slider_num').html(newValue);
                    }
                } else {
                    fatherRange = rangeWrapper.find('.range_slider');
                    boundRange = rangeWrapper.find('.range_slider_bound');
                    activeRange = rangeWrapper.find('.range_slider_track');
                    width = realWidth(fatherRange);
                    percBound = (maxBound - minBound) / (maxValue - minValue) || 0;
                    percFromValue = (fromValue - minBound) / (maxBound - minBound) || 0;
                    percActive = (toValue - fromValue) / (maxValue - minValue) || 0;
                    leftWidth = width * (minBound - minValue) / (maxValue - minValue) || 0;
                    newValue = '';

                    if (minValue === maxValue) {
                        percBound = 0;
                        leftWidth = 0;
                    }
                    rangeWrapper.find('.od-ui-range-slider-thumb-max').toggleClass('hidden', (minValue === maxValue));
                    rangeWrapper.find('.dates').toggleClass('disabled', (minValue === maxValue));

                    boundRange.css({
                        'width': '' + width * percBound + 'px',
                        'left': '' + leftWidth + 'px',
                    });
                    activeRange.css({
                        'width': '' + width * percActive + 'px',
                        'left': '' + width * percBound * percFromValue + 'px',
                    });
                    rangeWrapper.find('.range_slider_control').width(width * percActive + 'px');
                    rangeWrapper.find('.range_slider_thumb').attr({'title': newValue});
                    rangeWrapper.find('.range_slider_num').html(newValue);
                }

                rangeWrapper.find('.range_label_min').html(unitConfiguration.getMinLabel(minValue));
                rangeWrapper.find('.range_label_max').html(unitConfiguration.getMaxLabel(minValue, maxValue));
            };

            $(window).resize(changeRangeLook);

            if (textInputType === 'number') {
                $textInput.outerHtml(numberWrapper);
                $textInput = numberWrapper;
            } else if (textInputType === 'range') {
                rangeWrapper = $('<div>').addClass('od-ui-range');
                rangeWrapper.append(numberWrapper);

                // If there is no either min or max attribute -- don't render the slider.
                if ((minValue || minValue === 0) && (maxValue || maxValue === 0)) {
                    newTextInput.on('change-attr', function(event, attrs) {
                        var input = $(this);
                        $.each(attrs, function(key, value) {
                            switch (key) {
                                case 'min':
                                    minValue = value;
                                    break;
                                case 'max':
                                    maxValue = value;
                                    break;
                                case 'min-bound':
                                    minBound = (value >= minValue && value <= maxValue) ? value : minValue;
                                    break;
                                case 'max-bound':
                                    maxBound = (value >= minValue && value <= maxValue) ? value : maxValue;
                                    break;
                                case 'to':
                                    toValue = value;
                                    break;
                                case 'from':
                                    fromValue = value;
                                    break;
                            }
                            input.attr(key, value);
                        });
                        setNewValue();
                    });

                    minValue = parseFloat(minValue);
                    maxValue = parseFloat(maxValue);

                    // TODO: rewrite as Odigeo._.template. Had no time for that

                    var rangeDiv = $('<div>')
                        .addClass('od-ui-range-slider range_slider')
                        .append(
                            $('<div>')
                                .addClass('od-ui-range-slider-bound range_slider_bound')
                                .append(
                                    $('<div>')
                                        .addClass('od-ui-range-slider-track range_slider_track')
                                        .append(
                                            $('<div>')
                                                .addClass('od-ui-range-slider-value')
                                                .append(
                                                    $('<div>')
                                                        .addClass('od-ui-range-slider-control range_slider_control')
                                                        .attr({'tabindex': '0'})
                                                        .append(
                                                            $('<div>')
                                                                .addClass('od-ui-range-slider-thumb-max ')
                                                                .append(
                                                                    $('<div>')
                                                                        .addClass('od-ui-range-slider-thumb-click-max to range_slider_thumb')
                                                                        .attr({'title': '' + maxValue})
                                                                )
                                                        ).append(
                                                            $('<div>')
                                                                .addClass('od-ui-range-slider-num range_slider_num')
                                                                .addClass('od-hidden')
                                                                .html(maxValue)
                                                        )
                                                )
                                        )
                                )
                        );

                    if (labelVisibility) {
                        var labelDiv =
                            $('<div>')
                                .addClass('od-ui-range-labels-wrapper')
                                .append(
                                    $('<div>')
                                        .addClass('od-ui-range-label-min-wrapper')
                                        .append(
                                            $('<div>')
                                                .addClass('od-ui-range-label-min range_label_min')
                                                .html(minValue)
                                        )
                                )
                                .append(
                                    $('<div>')
                                        .addClass('od-ui-range-label-max-wrapper')
                                        .append(
                                            $('<div>')
                                                .addClass('od-ui-range-label-max range_label_max')
                                                .html(maxValue)
                                        )
                                );

                        rangeWrapper.append(
                            $('<div>')
                                .addClass('od-ui-range-wrapper')
                                .append(
                                    $('<div>')
                                        .addClass('od-ui-range-slider-wrapper')
                                        .append(rangeDiv)
                                        .append(labelDiv)
                                )
                        );
                    } else {
                        rangeWrapper.append(
                            $('<div>')
                                .addClass('od-ui-range-wrapper')
                                .append(
                                    $('<div>')
                                        .addClass('od-ui-range-slider-wrapper')
                                        .append(rangeDiv)
                                )
                        );
                    }

                    if (isDoubleRange) {
                        $(rangeWrapper).removeClass('od-ui-range').addClass('od-ui-range-double');
                        $(rangeWrapper).append($('<div>').addClass('od-ui-range-left-rounded'));
                        $(rangeWrapper).append($('<div>').addClass('od-ui-range-right-rounded'));
                        $('.range_slider_control', rangeWrapper).append(
                            $('<div>')
                                .addClass('od-ui-range-slider-thumb-min')
                                .append(
                                    $('<div>')
                                        .addClass('od-ui-range-slider-thumb-click-min range_slider_thumb from')
                                        .attr({'title': '' + maxValue})
                                )
                        );
                    } else {
                        if (style === 'line') {
                            $(rangeWrapper).removeClass('od-ui-range').addClass('od-ui-range-double');
                        } else {
                            $('.range_slider', rangeWrapper).append($('<div>').addClass('od-ui-range-slider-fix'));
                        }
                    }

                    if ($textInput.data('tip') === true) {
                        $('.range_slider_num', rangeWrapper).removeClass('od-hidden');
                    }

                    $textInput.outerHtml(rangeWrapper);
                    $textInput = rangeWrapper;

                    changeRangeLook(toValue);
                }
            }

            var validValue = function(newValue, rangeLimit) {
                var modulo = newValue % step;
                var steppedVal = newValue - modulo;

                if (newValue !== rangeLimit) {
                    if (modulo > step / 2) {
                        steppedVal += step;
                    }
                    newValue = steppedVal;

                    if ((maxBound || maxBound === 0) && newValue > maxBound) {
                        newValue = maxBound;
                    }

                    if ((minBound || minBound === 0) && newValue < minBound) {
                        newValue = minBound;
                    }
                }
                return newValue;
            };

            var setNewValue = function() {
                toValue = validValue(newTextInput.attr('to'), newTextInput.attr('max'));
                if (isNaN(toValue)) {
                    toValue = 1;
                }
                if (isDoubleRange) {
                    fromValue = validValue(newTextInput.attr('from'), newTextInput.attr('min'));
                }
                if (isDoubleRange && toValue < fromValue) {
                    toValue = fromValue;
                }
                if (isDoubleRange && fromValue > toValue) {
                    fromValue = toValue;
                }
                newTextInput.attr({'to': toValue});
                newTextInput.attr({'from': fromValue});

                if (rangeWrapper) {
                    changeRangeLook();
                }
            };

            if (rangeWrapper) {
                var trackW;
                var savedVal;
                var valueDiff;
                var mousePrevX;
                var mouseNewX;
                var mouseDiff;

                var trackDiffToValueDiff = function(trackDiff) {
                    trackW = realWidth(rangeWrapper.find('.range_slider_bound'));
                    return (trackDiff / trackW) * (Math.min(maxBound, maxValue) - Math.max(minBound, minValue));
                };

                var trackPointToValuePoint = function(trackPoint) {
                    return (trackDiffToValueDiff(trackPoint) + Math.max(minBound, minValue));
                };

                var startThumbDrag = function(event) {
                    event = event.type === 'pointerdown' ? event.originalEvent : event;

                    if (Odigeo.Session.get('UIRangeBlocked') === 'true') {
                        return;
                    }

                    Odigeo.Session.set('UIRangeBlocked', 'true');

                    if (!Odigeo._.isEmpty(event.touches)) {
                        mousePrevX = event.touches.item(0).clientX;
                    } else {
                        mousePrevX = event.pageX || event.clientX || event.layerX || event.screenX;
                    }
                    savedVal = $(event.target).hasClass('to') ? toValue : fromValue;
                    savedVal = parseFloat(savedVal);

                    // save prev handlers values
                    if ($(event.target).hasClass('to')) {
                        newTextInput.attr('prev-to', savedVal);
                    } else {
                        newTextInput.attr('prev-from', savedVal);
                    }

                    rangeWrapper.find('.range_slider_thumb').on(Odigeo.Events.touchend, stopThumbDrag);
                    rangeWrapper.find('.range_slider_thumb').on(Odigeo.Events.touchmove, doThumbDrag);

                    if (event.type === 'pointerdown' && this.setPointerCapture) {
                        this.setPointerCapture(event.pointerId);
                    }

                    // Hack to avoid swipe from being triggered
                    $.event.special.swipe.settings.sensitivity = -1;
                    $.event.special.swipe.settings.threshold = Infinity;
                };

                var doThumbDrag = function(event) {
                    event = event.type === 'pointermove' ? event.originalEvent : event;

                    if (minValue === maxValue) {
                        return;
                    }

                    if (!Odigeo._.isEmpty(event.touches)) {
                        mouseNewX = event.touches.item(0).clientX;
                    } else {
                        mouseNewX = event.pageX || event.clientX || event.layerX || event.screenX;
                    }

                    mouseDiff = (Odigeo._.isUndefined(mouseNewX) ? 0 : mouseNewX) - mousePrevX;
                    valueDiff = trackDiffToValueDiff(mouseDiff);
                    mousePrevX = mouseNewX;
                    savedVal += valueDiff;
                    if ($(event.target).hasClass('to')) {
                        newTextInput.attr({'to': savedVal});
                    } else if ($(event.target).hasClass('from')) {
                        newTextInput.attr({'from': savedVal});
                    }
                    setNewValue();

                    Odigeo.trigger('ui-range:doneThumbDrag', {'id': id, 'fromValue': fromValue, 'toValue': toValue});
                };

                var stopThumbDrag = function() {
                    var isEnabled;
                    var prevToVal = false;
                    var prevFromVal = false;
                    var toVal = false;
                    var fromVal = false;
                    var isToChangePermitted = true;
                    var isFromChangePermitted = true;
                    var isChangePermitted = false;
                    var input = newTextInput;

                    Odigeo.Session.set('UIRangeBlocked', 'false');

                    // prevent changing input in case it's disabled
                    isEnabled = !input.attr('disabled');

                    // get all handlers position data from input
                    if (input.attr('to')) {
                        toVal = input.attr('to');
                    }
                    if (input.attr('from')) {
                        fromVal = input.attr('from');
                    }
                    if (input.attr('prev-to')) {
                        prevToVal = input.attr('prev-to');
                    }
                    if (input.attr('prev-from')) {
                        prevFromVal = input.attr('prev-from');
                    }

                    // "to" same as before = false
                    if (toVal && prevToVal && toVal === prevToVal) {
                        isToChangePermitted = false;
                    }
                    if (!prevToVal) {
                        isToChangePermitted = false;
                    }

                    // "from" same as before = false
                    if (fromVal && prevFromVal && fromVal === prevFromVal) {
                        isFromChangePermitted = false;
                    }
                    if (!prevFromVal) {
                        isFromChangePermitted = false;
                    }

                    // save prev state
                    if (toVal) {
                        input.attr('prev-to', toVal);
                    }
                    if (fromVal) {
                        input.attr('prev-from', fromVal);
                    }

                    // one of both is different than before
                    if ((isToChangePermitted || isFromChangePermitted) && isDoubleRange) {
                        isChangePermitted = true;
                    }

                    if (isToChangePermitted && !isDoubleRange) {
                        isChangePermitted = true;
                    }

                    if (isEnabled && isChangePermitted) {
                        input.trigger('change');
                    }
                    rangeWrapper.find('.range_slider_thumb').off(Odigeo.Events.touchend, stopThumbDrag);
                    rangeWrapper.find('.range_slider_thumb').off(Odigeo.Events.touchmove, doThumbDrag);

                    // Hack to avoid swipe from being triggered
                    Odigeo._.delay(function() {
                        $.event.special.swipe.settings.sensitivity = 6;
                        $.event.special.swipe.settings.threshold = 0.4;
                    }, 200);
                };

                // initialing slider thumb dragging handler
                var bindDrag = function() {
                    rangeWrapper.removeClass('disabled');
                    rangeWrapper.find('.range_slider_thumb').on(Odigeo.Events.touchstart, startThumbDrag);
                    rangeWrapper.find('.range_slider_thumb').on(Odigeo.Events.swipeLeft, function(e) {
                        e.stopPropagation();
                    });
                };

                bindDrag();

                var unbindDrag = function() {
                    rangeWrapper.addClass('disabled');
                    rangeWrapper.find('.range_slider_thumb').off(Odigeo.Events.touchstart);
                    rangeWrapper.find('.range_slider_thumb').off(Odigeo.Events.swipeLeft);
                };

                newTextInput.on('disable', unbindDrag);
                newTextInput.on('enable', bindDrag);

                // initialing arrow keys press handling
                // TODO: REDO THIS FOR WORK ON DOUBLE CONTROL
                /* rangeWrapper.find('.od-input-range-control')
                 .on('focus', startThumbPress)
                 .on('focusout', stopThumbPress);*/

                var trackClick = function(event) {
                    // skipping events fired by thumb dragging
                    if (event.target === rangeWrapper.find('.range_slider_thumb')[0]) {
                        return;
                    }
                    var offsetX = event.offsetX || event.originalEvent.layerX;
                    var savedVal = trackPointToValuePoint(offsetX);
                    if (isDoubleRange) {
                        var middlePoint = minValue + ((maxValue - minValue) / 2);
                        if (savedVal < middlePoint) {
                            newTextInput.attr({'from': savedVal});
                        } else {
                            newTextInput.attr({'to': savedVal});
                        }
                    } else {
                        newTextInput.attr({'to': savedVal});
                    }
                    setNewValue();
                    Odigeo.trigger('ui-range:doneThumbDrag', {'id': id, 'fromValue': fromValue, 'toValue': toValue});
                    newTextInput.trigger('change');
                };

                // initialing track click handler
                // TODO: if touch rewrite `trackClick` to use event.touches.item(0)
                if (isDoubleRange) {
                    rangeWrapper.find('.range_slider_bound').on('click', trackClick);
                } else {
                    if (style === 'line') {
                        rangeWrapper.find('.range_slider_track').on('click', trackClick);
                    } else {
                        rangeWrapper.find('.od-ui-range-slider-fix').on('click', trackClick);
                    }
                }
            }
        }

        // Some Text-based inputs (text, search, tel, url, email, password, datetime, date, month,
        // week, time, datetime-local, color) with data-appearance="split" attribute
        // are parsed specifically:
        var splitAppearance = false;
        if ($textInput.attr('data-appearance') === 'split' && isInputElement) {
            var applicableTypes = ['text', 'search', 'tel', 'url', 'email',
                'password', 'datetime', 'date', 'month', 'week', 'time', 'datetime-local', 'color'];

            Odigeo._.each(applicableTypes, function(applicableType) {
                if (textInputType === applicableType) {
                    splitAppearance = true;
                }
            });
        }

        var textInputID = $textInput.attr('id');
        var textInputLabel = (textInputID && textInputID.length) ? $('label[for=' + textInputID + ']') : [];

        // If the input doesn't have an associated label, quit
        if (textInputLabel.length) {
            if (splitAppearance) {
                // Add class od-input-split-input to the input
                $textInput.removeClass('od-input-text').addClass('od-input-split-input');

                // Add class od-input-split-label to the label
                textInputLabel.addClass('od-input-split-label');

                // Wrap both in .od-input-split
                var splitDiv = $('<div>').addClass('od-input-split');

                // Wrap the label in .od-grid-unit.od-input-split-part1
                splitDiv.append($('<div>').addClass('od-grid-unit od-input-split-part1').append(textInputLabel));

                // Wrap the input in .od-grid-unit.od-input-split-part2
                splitDiv.append($('<div>').addClass('od-grid-unit od-input-split-part2').append($textInput.clone()));

                $textInput.outerHtml(splitDiv);
            } else {
                // If inputs of the named types and textarea have a label associated to them (with "for" attribute
                // with a value equal to input "id" attribute), the label is assigned a class name of "od-label"
                textInputLabel.addClass('od-label');
            }
        }
    };

    var UnitTypeConfiguration = function() {
        this.getMinLabel = function(minValue) {
            return minValue;
        };
        this.getMaxLabel = function(minValue, maxValue) {
            return maxValue;
        };
    };

    var TimeUnitTypeConfiguration = function(letter) {
        this.symbol = letter || 'h';
    };
    TimeUnitTypeConfiguration.prototype = new UnitTypeConfiguration();
    TimeUnitTypeConfiguration.prototype.constructor = TimeUnitTypeConfiguration;
    TimeUnitTypeConfiguration.prototype.getMinLabel = function(minValue) {
        return ((13640000 < minValue) ? Odigeo.Utils.formatDate(minValue, 'hourMinutes', true) : minValue) + this.symbol;
    };
    TimeUnitTypeConfiguration.prototype.getMaxLabel = function(minValue, maxValue) {
        var differenceInDays = Odigeo.Utils.formatDate(maxValue, 'justDay', true) - Odigeo.Utils.formatDate(minValue, 'justDay', true);
        var labelMax = differenceInDays > 0 ? ' (+' + differenceInDays + ')' : '';
        return ((13640000 < maxValue) ? Odigeo.Utils.formatDate(maxValue, 'hourMinutes', true) : maxValue) + this.symbol + labelMax;
    };

    var DistanceUnitTypeConfiguration = function() {
    };
    DistanceUnitTypeConfiguration.prototype = new UnitTypeConfiguration();
    DistanceUnitTypeConfiguration.prototype.constructor = DistanceUnitTypeConfiguration;
    DistanceUnitTypeConfiguration.prototype.getMinLabel = function(minValue) {
        return minValue + 'km';
    };
    DistanceUnitTypeConfiguration.prototype.getMaxLabel = function(minValue, maxValue) {
        return maxValue + 'km';
    };
}());
